import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
    const { auth } = useAuth();
    const location = useLocation();

    if (!auth?.accessToken) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // If allowedRoles specified, check role matches
    if (allowedRoles && allowedRoles.length > 0) {
        if (!allowedRoles.includes(auth?.role)) {
            return <Navigate to="/NotFound" state={{ from: location }} replace />;
        }
    }

    return <Outlet />;
}

export default RequireAuth;
